import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M3.524 19h12.952c1.71 0 2.524-.486 2.524-1.555 0-2.546-3.41-6.23-8.995-6.23C4.41 11.215 1 14.899 1 17.445 1 18.515 1.814 19 3.524 19m-.484-1.468c-.268 0-.381-.068-.381-.272 0-1.603 2.617-4.578 7.346-4.578 4.72 0 7.336 2.975 7.336 4.578 0 .204-.103.272-.37.272zM10.005 10c2.452 0 4.451-2.05 4.451-4.558A4.42 4.42 0 0 0 10.006 1a4.463 4.463 0 0 0-4.452 4.461C5.554 7.96 7.553 10 10.005 10m0-1.468c-1.504 0-2.792-1.35-2.792-3.07 0-1.692 1.267-2.994 2.792-2.994 1.535 0 2.792 1.273 2.792 2.974 0 1.72-1.277 3.09-2.792 3.09"
    }, null, -1)
  ])))
}
export default { render: render }